import React from 'react';
export function PurchaseSteps() {
  return <section className="w-full bg-white pt-6 md:pt-8 pb-2 md:pb-4 px-4" data-id="element-366">
      <div className="max-w-md mx-auto border-2 border-gray-200 rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-367">
        <p className="text-lg md:text-xl font-black text-gray-900 font-heading mb-5 text-center" data-id="element-368">
          Realiza tu compra de forma sencilla e inmediata:
        </p>
        <div className="flex flex-col gap-3 max-w-xs mx-auto" data-id="element-369">
          <div className="flex items-center gap-3" data-id="element-370">
            <span className="bg-yellow-400 text-gray-900 font-black text-base w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-heading" data-id="element-371">
              1
            </span>
            <span className="text-gray-800 font-body text-base md:text-lg font-semibold" data-id="element-372">
              Completa tus datos
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-373">
            <span className="bg-yellow-400 text-gray-900 font-black text-base w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-heading" data-id="element-374">
              2
            </span>
            <span className="text-gray-800 font-body text-base md:text-lg font-semibold" data-id="element-375">
              Realiza el pago seguro
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-376">
            <span className="bg-yellow-400 text-gray-900 font-black text-base w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-heading" data-id="element-377">
              3
            </span>
            <span className="text-gray-800 font-body text-base md:text-lg font-semibold" data-id="element-378">
              Accede Inmediatamente
            </span>
          </div>
        </div>
      </div>
    </section>;
}